import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { MODAL_QUERY_PARAM, type ModalKey } from '@/shared/config/modals';

export const useModalParams = (modalKey: ModalKey) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const isOpen = searchParams.get(MODAL_QUERY_PARAM) === modalKey;

  const open = useCallback(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set(MODAL_QUERY_PARAM, modalKey);
      return newParams;
    });
  }, [modalKey, setSearchParams]);

  const close = useCallback(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.delete(MODAL_QUERY_PARAM);
      return newParams;
    });
  }, [setSearchParams]);

  const toggle = useCallback(() => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }, [isOpen, open, close]);

  return {
    isOpen,
    open,
    close,
    toggle
  };
};
